import { Box } from "@chakra-ui/react"
import type { BoxProps } from "@chakra-ui/react"

interface SkeletonProps extends BoxProps {
  isLoaded?: boolean
  children?: React.ReactNode
}

export const Skeleton = ({
  isLoaded = false,
  children,
  ...props
}: SkeletonProps) => {
  if (isLoaded && children) {
    return <>{children}</>
  }

  return (
    <Box
      bg="gray.200"
      borderRadius="md"
      animation="pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
      css={{
        "@keyframes pulse": {
          "0%, 100%": { opacity: 1 },
          "50%": { opacity: 0.5 },
        },
      }}
      {...props}
    />
  )
}

export default Skeleton
